import React from 'react';
import InfoIcon from '@atlaskit/icon/core/migration/information--info';
import { Box, xcss } from '@atlaskit/primitives';
import ProgressBar from '@atlaskit/progress-bar';
import { token } from '@atlaskit/tokens';
import { InfoFlag } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import type { FlagCustomRenderProps } from '@atlassian/jira-flags/src/services/types'; // ignore-for-ENGHEALTH-17759
import { useIntl } from '@atlassian/jira-intl';
import { useFormSubmitProgressData } from '../../../../controllers/use-form-submit-state/main.tsx';
import { TEST_ID, FLAG_ID } from './constants.tsx';
import messages from './messages.tsx';

type Props = {
	onDismissed: () => void;
} & FlagCustomRenderProps;

export const InProgressFlag = ({ onDismissed, ...props }: Props) => {
	const { formatMessage } = useIntl();
	const progressData = useFormSubmitProgressData();
	const progress = progressData?.progress;

	return (
		<InfoFlag
			{...props}
			testId={TEST_ID}
			icon={<InfoIcon spacing="spacious" color={token('color.icon.information')} label="" />}
			id={FLAG_ID}
			title={formatMessage(messages.title)}
			description={
				<>
					{formatMessage(messages.description)}
					<Box xcss={progressBarContainerStyles}>
						<ProgressBar
							ariaLabel={formatMessage(messages.title)}
							isIndeterminate={!progress}
							value={progress}
						/>
					</Box>
				</>
			}
			onDismissed={onDismissed}
			messageId="bulk-operations-common.ui.submit-status.flags.in-progress-flag.info-flag.in-progress-flag"
			messageType="transactional"
		/>
	);
};

const progressBarContainerStyles = xcss({
	paddingTop: 'space.200',
});
